import { create } from 'jss';
import { jssPreset } from '@material-ui/core/styles';

// Define a custom insertion point that JSS will look for when injecting the styles into the DOM.
// This exists to ensure that Emotion style tags are injected after MUI JSS tags
export const jss = create({
  ...jssPreset(),
  insertionPoint: 'jss-insertion-point',
});
